export default {
  header: 'Someting unexpected happened',
  text: 'We ask you to let one of our employees know, so that we can restart the digital stamp card 😊.',
  button: 'Return To Start',
};
